import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Collapse } from 'reactstrap';

import { BidCheckStatuses } from '../constants';

const CheckItem = ({
    item,
    t,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const statusInfos = BidCheckStatuses[item.status];

    return (
        <div className="border rounded p-3 mb-2">
            <button
                className="btn btn-link text-reset text-decoration-none p-0 w-100"
                onClick={() => setIsOpen((open) => !open)}
                type="button"
            >
                <div className="d-flex align-items-start text-start">
                    <span className={`avatar-xs me-2 text-${statusInfos.color}`}>
                        <span className={`avatar-title rounded-circle bg-soft-${statusInfos.color} text-${statusInfos.color}`}>
                            <i className={item.icon} />
                        </span>
                    </span>

                    <div className="flex-grow-1">
                        <b className="d-block">{t(item.title)}</b>
                        <small className="text-muted">{t(item.description)}</small>
                    </div>

                    <span className={`badge p-2 me-2 ${statusInfos.className}`}>
                        {t(statusInfos.title)}
                    </span>
                    <i className={isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
                </div>
            </button>

            <Collapse isOpen={isOpen}>
                <p className="text-muted mb-0 mt-2 ps-5">
                    {t(item.details || item.description)}
                </p>
            </Collapse>
        </div>
    );
};

const CheckList = ({
    count,
    items = [],
    title,
    t,
}) => {
    if (!items.length) return null;

    return (
        <div className="mb-3">
            <h5 className="fw-bold mb-3">
                {t(title)}
                <span className="badge badge-soft-secondary ms-2">{count ?? items.length}</span>
            </h5>

            {items.map((item) => (
                <CheckItem item={item} key={item.id} t={t} />
            ))}
        </div>
    );
};

export default withNamespaces()(
    CheckList
);
